export enum BreadcrumbType {
  ORGANIZATION = 'organization',
  PROJECT = 'project',
  APPLICATION = 'application',
}
